import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { usePayrollCountry } from '../../hooks/usePayrollCountry';
import { DashboardLayout } from '../layout/DashboardLayout';
import { Button } from '../ui/button';

// Countries where the payroll module is offered (mirrors backend PAYROLL_LAUNCH_COUNTRIES_DEFAULT)
export const PAYROLL_LAUNCH_COUNTRIES = ['US', 'NG', 'GB', 'KE', 'ZA', 'TZ', 'GH', 'UG'];
export const isPayrollCountry = (code) => PAYROLL_LAUNCH_COUNTRIES.includes(String(code || '').toUpperCase());

/** Launch gate: when the backend reports payroll_available=false, payroll routes show a "not available yet" notice instead of the module. */
export function PayrollCountryGate({ children }) {
  const pc = usePayrollCountry();
  if (pc.loading) return <DashboardLayout><div className="p-8 text-sm text-muted-foreground" data-testid="payroll-gate-loading">Loading payroll…</div></DashboardLayout>;
  if (pc.payroll_available === false) {
    return (
      <DashboardLayout>
        <div className="max-w-xl mx-auto mt-16 text-center space-y-4" data-testid="payroll-unavailable">
          <div className="w-14 h-14 rounded-full bg-slate-100 flex items-center justify-center mx-auto"><Globe className="w-7 h-7 text-slate-500" /></div>
          <h1 className="text-2xl font-semibold">Payroll isn't available in {pc.code || 'your country'} yet</h1>
          <p className="text-sm text-muted-foreground" data-testid="payroll-unavailable-countries">
            AkountFly payroll currently supports {PAYROLL_LAUNCH_COUNTRIES.join(', ')}. We're adding more countries — you'll see Payroll appear here when yours goes live.
          </p>
          <Button asChild variant="outline" data-testid="payroll-unavailable-home"><Link to="/dashboard">Back to dashboard</Link></Button>
        </div>
      </DashboardLayout>
    );
  }
  return children;
}
